import { GoogleService } from '@core/auth/services/google.service';
import { AuthService } from '@core/auth/services/auth.service';

export const SERVICES = [
  GoogleService,
  AuthService
];
